// eslint-disable-next-line no-restricted-imports -- TODO: update to `next/navigation` before using this component in App Router
import { useRouter } from "next/router";

import isMobileDevice from "utils/isMobileDevice";

import GoogleAd from "@/components/GoogleAd";

import { hasIosParam } from "../lib/paramCheck";

const ProductsAd: React.FC<{
  className?: string;
  sizes?: Record<string, googletag.GeneralSize>;
  unit: string;
}> = ({ className, sizes, unit }) => {
  const router = useRouter();
  const isIos = hasIosParam(router);

  const {
    query: { category, subcategory },
  } = router;

  return (
    <GoogleAd
      targeting={{
        "brand-expression": "true",
        device: isMobileDevice() ? (isIos ? "ios-app" : "android-app") : "web",
        "product-category": category || "home",
        "product-subcategory": subcategory,
      }}
      adPath={`/13212770/product/${unit}`}
      className={className}
      sizes={sizes}
    />
  );
};

export default ProductsAd;
